<template>
  <div class="user" v-loading="loading">
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <div class="common-form">云仓设置</div>
      <el-form-item label="是否开启云仓：">
        <el-radio-group v-model="form.open_cloud_warehouse">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="选择购买云仓等级： ">
        <el-select v-model="form.warehouse_grade" multiple placeholder="请选择" style="width: 250px">
          <el-option v-for="(item,index) in gradeList" :key="index" :label="item.name"  :value="item.grade_id">
          </el-option>
        </el-select>
          <div class="gray9">开启后，只有选中的会员等级才能购买云仓</div>
      </el-form-item>
      <el-form-item label="是否只有特定商品才能购买云仓：">
        <el-radio-group v-model="form.is_use_alone_product">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
        <div class="gray9">开启并选择至少一个产品后，只有选中的产品才能购买云仓</div>
      </el-form-item>
      <el-form-item label="商品管理" prop="product_list" v-if="form.is_use_alone_product == 1">
        <el-button icon="el-icon-plus" @click="changeProduct(product_list)">选择商品</el-button>
        <div class="pt16">
          <el-table size="mini" :data="product_list" border style="width: 400px;">
            <el-table-column label="商品名称">
              <template slot-scope="scope">
                <p class="text-ellipsis-2">{{ scope.row.product_name }}</p>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="100">
              <template slot-scope="scope">
                <el-button @click="deleteClick(scope.$index)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>
      <el-form-item label="是否开启下级购买减云仓：">
        <el-radio-group v-model="form.open_reduce_warehouse">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
        <div class="gray9">开启后，当上级云仓大于下级购买商品数量时，上级减云仓获得下级购买金额</div>
      </el-form-item>

      <!--商品选择-->
      <Product :isproduct="isproduct" :excludeIds="excludeIds" :islist="true" @closeDialog="closeDialogFunc"></Product>
    </el-form>

    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">保存</el-button>
    </div>
  </div>

</template>

<script>
  import Product from '@/components/product/Product.vue';
  import WarehouseApi from '@/api/warehouse.js'
  import { mergeTable } from '@/utils/table.js';
export default {
  components: {
    /*选择商品组件*/
    Product,
  },
  data() {
    return {
      /*是否正在加载*/
      loading: true,
      /*是否打开选择商品*/
      isproduct: false,
      /*表单对象*/
      form: {
        /*是否开启*/
        open_cloud_warehouse: 0,
        //购买云仓等级
        warehouse_grade: [],
        /*是否只有特定商品才能购买云仓*/
        is_use_alone_product: 0,
        /*是否开启下级购买减云仓*/
        open_reduce_warehouse: 0,
      },
      /*商品列表*/
      product_list:[],
      gradeList: [],
      /*产品去重*/
      excludeIds: [],
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*获取数据*/
    getData(){
      let self = this;
      self.loading = true;
      WarehouseApi.getData({}, true)
        .then(res => {
          self.form = res.data.detail;
          self.product_list = res.data.product_list;
          self.gradeList = res.data.gradeList;
          self.loading = false;
        })
        .catch(error => {});
    },

    /*提交表单*/
    onSubmit() {
      let self = this;
      self.loading = true;
      let arr = [];
      self.product_list.forEach(item => {
        arr.push(item.product_id);
      });
      self.form.warehouse_product = arr;
      let params = self.form;
      // console.log(params);
      WarehouseApi.saveData(self.form, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '恭喜你，保存成功',
            type: 'success'
          });
          this.getData();
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*打开添加*/
    changeProduct(list) {
      let arr = [];
      list.forEach(item => {
        arr.push(item.product_id);
      });
      this.excludeIds = arr;
      this.isproduct = true;
    },

    /*关闭弹窗*/
    closeDialogFunc(e) {
      let self = this;
      self.isproduct = false;
      if (e.type == 'success') {
        let arr = [];
        for (let i = 0; i < e.params.length; i++) {
          let item = e.params[i];
          let obj = {
            product_name: item.product_name,
            product_id: item.product_id,
          };
          arr.push(obj);
        }
        self.product_list = self.product_list.concat(arr);
        self.product_list = mergeTable(this.product_list);
      }
    },
    /*删除*/
    deleteClick(e) {
      let curItem=this.product_list[e];
      /*判断能删除产品*/
      for (let i = 0; i < this.product_list.length; i++) {
        let item = this.product_list[i];
        if (curItem.product_id == item.product_id) {
          this.product_list.splice(i, 1);
          i--;
        }
      }
      if (this.product_list.length > 0) {
        this.product_list = mergeTable(this.product_list);
      }else{
        this.product_list = [];
      }
    },
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/warehouse/setting/index.vue